import { theme } from '@/styles';
import React from 'react';
import styled, { css } from 'styled-components';

type VariantType = 'imgBG' | 'whiteBG';
interface FlagVrPropsType {
  value?: number;
  variant?: VariantType;
}

const FlagVr = ({ value = 720, variant = 'imgBG' }: FlagVrPropsType) => {
  return (
    <FlagVrWrapper variant={variant}>
      <FlagWrap variant={variant}>{value} VR</FlagWrap>
    </FlagVrWrapper>
  );
};

export default FlagVr;

const CommonColor = {
  gray: 'rgba(0, 0, 0, 0.16)',
  black: theme.colors.accent_colors.primary.default,
  white: theme.colors.neutral_colors.white,
};

const CommonCSS = css`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

const FlagVrWrapper = styled.div<{ variant?: VariantType }>`
  width: 70px;
  height: 28px;
  border: 0.5px solid
    ${({ variant }) =>
      variant === 'imgBG' ? CommonColor.white : CommonColor.black};
  ${CommonCSS}
`;

const FlagWrap = styled.div<{ variant?: VariantType }>`
  ${theme.typography.button.sm_b};
  width: 66px;
  height: 24px;
  background-color: ${({ variant }) =>
    variant === 'imgBG' ? CommonColor.gray : CommonColor.white};
  color: ${({ variant }) =>
    variant === 'imgBG' ? CommonColor.white : CommonColor.black};
  ${CommonCSS}
`;
